







































































































































// decoradores
import { Vue, Component } from "vue-property-decorator";
// vuex
import { mapActions, mapGetters } from "vuex";
// tipos

// componentes
import TablaCodCuenta from "@/components/codCuentas/Tabla.vue";
import FormularioCodCuenta from "@/components/codCuentas/Formulario.vue";
import { DataFormularioCodCuenta } from "@/typings/components/codCuentas/formulario";
import DialogoExito from "@/components/DialogoExito.vue";
import DialogoEliminar from "@/components/DialogoEliminar.vue";
import InfoCodCuenta from "@/components/codCuentas/Info.vue";
//import BotonesCrud from "@/components/BotonesCrud.vue";
import MensajeEliminar from "@/components/MensajeEliminar.vue";
//import TituloVista from "@/components/TituloVista.vue";
import {
  CodCuenta,
  CodCuentas,
  //  Regiones,
} from "@/typings/store/plugins/easyFirestore/codCuentas";
import CargarCodCuentasExcel from "@/components/excel/CargarTipoCodCuentas.vue";
import ExportarExcelGenerico from "@/components/ExportarExcelGenerico.vue";
import ExportarPdfGenerico from "@/components/ExportarPdfGenerico.vue";

//import { DataFormularioRegion } from "@/typings/components/regiones/formulario";

const routeGuard = (vm: Vue): boolean => {
  const permisos = vm.getUsuario?.permisos;
  if (permisos && permisos["codCuentas"]) {
    return true;
  }

  const rutas = vm.getRutasUsuario;
  if (rutas.length > 0) {
    const to = rutas[0].to;
    if (to) {
      if (vm.$route.name !== to.name) {
        vm.$router.replace(to);
      }
      return false;
    }
  }
  if (vm.$route.name !== "inicio") {
    vm.$router.replace({ name: "inicio" });
  }
  return false;
};

@Component({
  computed: mapGetters({
    getUsuarios: "usuarios/get",
    getCodCuentas: "codCuentas/get",
    getArrayUsuarios: "usuarios/getArray",
    getUsuario: "usuario/get",
    getRutas: "rutas/get",

    getRutasUsuario: "usuario/getRutas",
    getArrayCodCuentas: "codCuentas/getArray",
  }),
  methods: mapActions({
    setCodCuenta: "codCuentas/set",
    deleteCodCuenta: "codCuentas/delete",
    insertBatchCodCuentas: "codCuentas/insertBatch",
    //setArchivo: "archivos/set",
    //deleteArchivo: "archivos/delete",
  }),
  beforeRouteEnter(to, from, next) {
    next(routeGuard);
  },
  components: {
    DialogoEliminar,
    DialogoExito,
    TablaCodCuenta,
    FormularioCodCuenta,
    InfoCodCuenta,
    MensajeEliminar,
    CargarCodCuentasExcel,
    ExportarExcelGenerico,
    ExportarPdfGenerico,
  },
})
export default class VistaBancos extends Vue {
  created(): void {
    if (!routeGuard(this)) {
      return;
    }
  }

  cargando = false;
  dialogoExito = {
    model: false,
    texto: "",
    icono: "",
  };
  search = "";
  codCuenta: CodCuenta | null = null;
  dialogoInfo = false;
  dialogoFormulario = false;
  dialogoEliminar = false;
  textoEliminar = "¿ESTÁS SEGURO QUE DESEAS ELIMINAR ESTA CUENTA?";
  dialogoCargarExcel = false;

  get codCuentas(): CodCuentas {
    return this.getCodCuentas;
  }

  get items(): Array<CodCuenta> {
    return this.getArrayCodCuentas;
  }

  get columnasExportacionCodCuentas(): Array<{ label: string; field: string }> {
    return [
      { label: "PCCODI", field: "PCCODI" },
      { label: "PCNIVEL", field: "PCNIVEL" },
      { label: "PCLNIVEL", field: "PCLNIVEL" },
      { label: "PCDESC", field: "PCDESC" },
      { label: "PCCODI2", field: "PCCODI2" },
    ];
  }

  clickItem(val: { id: string } | null): void {
    this.codCuenta = val ? this.codCuentas[val.id] : null;
  }

  clickPlus(): void {
    this.codCuenta = null;
    this.dialogoFormulario = true;
  }

  async clickGuardar(data: DataFormularioCodCuenta): Promise<void> {
    this.cargando = true;
    const doc = data.doc;
    await this.setCodCuenta(doc);
    if (doc.id != this.codCuenta?.id) {
      this.dialogoExito = {
        model: true,
        texto: "¡Banco creado con éxito!",
        icono: require("../assets/icons/double-check-duo.svg"),
      };
    }
    if (doc.id == this.codCuenta?.id) {
      this.dialogoExito = {
        model: true,
        texto: "¡Banco editado con éxito!",
        icono: require("../assets/icons/editar.svg"),
      };
      this.codCuenta = doc;
    }
    this.cerrarDialogoFormulario();
    this.cargando = false;
  }

  cerrarDialogoExito(): void {
    this.dialogoExito = {
      model: false,
      texto: "",
      icono: "",
    };
  }

  clickEliminar(): void {
    const codCuenta = this.codCuenta;
    if (!codCuenta?.id) {
      console.error("error id: ", codCuenta);
      return;
    }
    this.deleteCodCuenta(codCuenta.id);
    this.codCuenta = null;
    this.cerrarDialogoEliminar();
  }

  abrirDialogoInfo(codCuenta: CodCuenta): void {
    if (!codCuenta.id) {
      console.error("error id: ", codCuenta);
      return;
    }
    const doc = this.codCuentas[codCuenta.id];
    if (doc) {
      this.codCuenta = doc;
      this.dialogoInfo = true;
    }
  }

  cerrarDialogoInfo(): void {
    this.dialogoInfo = false;
    this.codCuenta = null;
  }

  abrirDialogoFormulario(codCuenta: CodCuenta): void {
    if (!codCuenta.id) {
      console.error("error id: ", codCuenta);
      return;
    }
    const doc = this.codCuentas[codCuenta.id];
    if (doc) {
      this.codCuenta = doc;
      this.dialogoFormulario = true;
    }
  }

  abrirDialogoEliminar(codCuenta: CodCuenta): void {
    if (!codCuenta.id) {
      console.error("error id: ", codCuenta);
      return;
    }
    const doc = this.codCuentas[codCuenta.id];
    if (doc) {
      this.dialogoEliminar = true;
      this.codCuenta = doc;
    }
  }

  cerrarDialogoEliminar(): void {
    this.dialogoEliminar = false;
    this.codCuenta = null;
  }

  cerrarDialogoFormulario(): void {
    this.dialogoFormulario = false;
    this.codCuenta = null;
  }
}
